import React, { useMemo, useState } from "react";
import { api } from "../api";

function normalizeRc(value) {
    return (value || "").replaceAll(" ", "").replaceAll("/", "").trim();
}
function normalizeName(value) {
    return (value || "").trim().replace(/\s+/g, " ").toUpperCase();
}

export default function Register() {
    const [name, setName] = useState("");
    const [rc, setRc] = useState("");
    const [note, setNote] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [msg, setMsg] = useState("");

    const payload = useMemo(() => {
        return { name: normalizeName(name), rc: normalizeRc(rc), note: note || "" };
    }, [name, rc, note]);

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setMsg("");

        if (!payload.name || !payload.rc) {
            setErr("missing_fields");
            return;
        }

        setBusy(true);
        try {
            const res = await api.register(payload.name, payload.rc, payload.note);
            if (res.created) setMsg("Záznam byl zapsán.");
            else setMsg("Shodný doklad už existuje.");
            setName("");
            setRc("");
            setNote("");
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "register_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="card overflow-hidden">
            <div className="cardHeader">
                <div className="text-text-100 font-extrabold text-2xl">Registrace dokladu</div>
                <div className="text-text-300 mt-2">Vytvoří nový záznam</div>
            </div>

            <div className="cardBody">
                <form onSubmit={onSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                        <div>
                            <div className="label">Jméno a příjmení</div>
                            <input value={name} onChange={(e) => setName(e.target.value)} className="input mt-3" placeholder="JAN NOVÁK" autoComplete="off" />
                        </div>

                        <div>
                            <div className="label">Rodné číslo</div>
                            <input value={rc} onChange={(e) => setRc(e.target.value)} className="input mt-3" placeholder="990101/1234" inputMode="numeric" autoComplete="off" />
                        </div>
                    </div>

                    <div>
                        <div className="label">Poznámka</div>
                        <textarea value={note} onChange={(e) => setNote(e.target.value)} className="input mt-3 min-h-[110px] resize-none" placeholder="Volitelné" />
                    </div>

                    {err ? (
                        <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                            <div className="text-text-100 font-semibold">Nelze zapsat</div>
                            <div className="text-text-200 text-sm mt-1">{err}</div>
                        </div>
                    ) : null}

                    {msg ? (
                        <div className="rounded-2xl border border-ok/35 bg-ok/10 p-4">
                            <div className="text-text-100 font-semibold">{msg}</div>
                        </div>
                    ) : null}

                    <div className="flex flex-col sm:flex-row gap-3">
                        <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed" : "btnPrimary"}>
                            {busy ? "Zapisuji" : "Zapsat"}
                        </button>
                        <button
                            type="button"
                            className="btnGhost"
                            onClick={() => {
                                setName("");
                                setRc("");
                                setNote("");
                                setErr("");
                                setMsg("");
                            }}
                        >
                            Vyčistit
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}
